import CollageRegister from "../ui/collage/CollageRegister";
import MentorRegister from "../ui/Mentor/MentorRegister";
import ProjectsList from "../ui/projects/ProjectsList";
import RoboticLabSetup from "../ui/robotic-lab/RoboticLabSetup";
import ServicesList from "../ui/services/ServicesList";
import Home from "./home/Home";
import QuizeGame from "./quizes/QuizeGame";
import QuizePage from "./quizes/QuizePage";
import CustomerProjectRequirements from "./services/CustomerProjectRequirements";
import ProgramPage from "./program/ProgramPage";
import ProgramDetailsPage from "./program/ProgramDetailsPage";
import KIdsCoursePage from "./kids/KIdsCoursePage";
import Roboticsyllabus from "./robotic-lab/Roboticsyllabus";
import CampusToCorporate from "./campus-to-corporate/CampusToCorporate";
import RoboticsRegistration from "./robotic-lab/RoboticsRegistration";
import KidaCourseDetailPage from "./kids/KidaCourseDetailPage";
import Otg from "./otg/Otg";
import HireUs from "./hireus/HireUs";
import { uiRoutes } from "../../routes/ui/uiRoutes";

export const uiConfig = [
  {
    path: uiRoutes.website.home,
    element: <Home />,
  },
  {
    path: uiRoutes.website.services,
    element: <ServicesList />,
  },
  {
    path: uiRoutes.website.project,
    element: <ProjectsList />,
  },
  {
    path: uiRoutes.website.collegeRegister,
    element: <CollageRegister />,
  },
  {
    path: uiRoutes.website.mentorRegister,
    element: <MentorRegister />,
  },
  {
    path: uiRoutes.website.roboticLab,
    element: <RoboticLabSetup />,
  },
  {
    path: uiRoutes.website.addProjectRequirements,
    element: <CustomerProjectRequirements />,
  },
  {
    path: uiRoutes.website.quize,
    element: <QuizePage />,
  },
  {
    path: uiRoutes.website.quizeShow,
    element: <QuizeGame />,
  },
  {
    path: uiRoutes.website.programs,
    element: <ProgramPage />,
  },
  {
    path: uiRoutes.website.programDetails,
    element: <ProgramDetailsPage />,
  },
  {
    path: uiRoutes.website.kids,
    element: <KIdsCoursePage />,
  },
  {
    path: uiRoutes.website.roboticSyllabus,
    element: <Roboticsyllabus />,
  },
  {
    path: uiRoutes.website.kidsCourseDetail,
    element: <KidaCourseDetailPage />,
  },
  {
    path: uiRoutes.website.campusToCorporate,
    element: <CampusToCorporate />,
  },
  {
    path: uiRoutes.website.roboticRegister,
    element: <RoboticsRegistration />,
  },
  {
    path: uiRoutes.website.ojt,
    element: <Otg />,
  },
  {
    path: uiRoutes.website.hireUs,
    element: <HireUs />,
  },
];
